<div class="mainDialog" style=" border: 5px solid grey; border-radius: 20px;">
    
    <div style="text-align: center;" mat-dialog-content>    
        <img src="../../../../assets/img/icones/warning2.png">
        <div class="titleDialog">
            <p>{{ dialogTitle }}</p>
        </div>
        <div *ngIf="dialogText.length > 0" class="labelDialog">
            <label style="text-align: center; color: red;">{{ dialogText }}</label>
        </div>
    </div>
    <div mat-dialog-actions align="center">
        <button mat-raised-button color="warn" (click)="onConfirm(false)">Não</button>
        <button mat-raised-button color="primary" (click)="onConfirm(true)">Sim</button>
    </div>
</div>
